import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Button,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Grid,
    Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { listPresentationsByGroup } from './apigroup';
import { isAuthenticated } from '../auth';


class PresentationList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            presentations21: [],
            presentations22: [],
            presentations23: [],
            presentations24: [],
            presentations25: [],
            presentations26: [],
            groupId: this.props.groupId,
            eventId: '',
            expanded: 'panel2026' // Default to 2026 expanded
        };
    }

    token = isAuthenticated() && isAuthenticated().token;

    handleAccordionChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    list2021Presentations = (groupId) => {
        listPresentationsByGroup(groupId, isAuthenticated() && isAuthenticated().token, '2021').then(data => {
            this.setState({
                presentations21: data || []
            });
        });
    };

    list2022Presentations = (groupId) => {
        listPresentationsByGroup(groupId, isAuthenticated() && isAuthenticated().token, '2022').then(data => {
            this.setState({
                presentations22: data || []
            });
        });
    };

    list2023Presentations = (groupId) => {
        listPresentationsByGroup(groupId, isAuthenticated() && isAuthenticated().token, '2023').then(data => {
            this.setState({
                presentations23: data || []
            });
        });
    };

    list2024Presentations = (groupId) => {
        listPresentationsByGroup(groupId, isAuthenticated() && isAuthenticated().token, '2024').then(data => {
            this.setState({
                presentations24: data || []
            });
        });
    };

    list2025Presentations = (groupId) => {
        listPresentationsByGroup(groupId, isAuthenticated() && isAuthenticated().token, '2025').then(data => {
            this.setState({
                presentations25: data || []
            });
        });
    };

    list2026Presentations = (groupId) => {
        listPresentationsByGroup(groupId, isAuthenticated() && isAuthenticated().token, '2026').then(data => {
            this.setState({
                presentations26: data || []
            });
        });
    };

    setEventId(groupId) {
        switch (groupId) {
            case '5e2a5e764175b97d84ec6cae':
                // physical
                return '6001d4e256a94550905723b1';
            case '5e44050f4e6ed37ab467d0f2':
                // electrical
                return '61e998f4f5b727e70e24bfef';
            case '5e44052e4e6ed37ab467d0f3':
                // Technology
                return '6001d42856a94550905723ae';
            case '5e4405864e6ed37ab467d0f4':
                // civil
                return '61e9992cf5b727e70e24bff0';
            case '5e4406454e6ed37ab467d0f5':
                // bizstrategy
                return '6001d4b056a94550905723b0';
            case '5e5591a97ff73f6d34835a05':
                // leadership
                return '63a331bc377a80f363a8073d';
            case '639242d4971a30726884fd85':
                // innovative solutions
                return '640f65606164bc23c3f3eb4e';
            default:
                return '';
        }
    }

    componentDidMount() {
        const eventId = this.setEventId(this.props.groupId);
        this.list2021Presentations(eventId);
        this.list2022Presentations(eventId);
        this.list2023Presentations(eventId);
        this.list2024Presentations(eventId);
        this.list2025Presentations(eventId);
        this.list2026Presentations(eventId);
    }

    renderPresentations = (presentations, year) => {
        if (!presentations || presentations.length === 0) {
            return (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                    <VideoLibraryIcon sx={{ fontSize: 48, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                    <Typography variant="body1" color="text.secondary">
                        No {year} recordings found
                    </Typography>
                </Box>
            );
        }

        return (
            <Grid container spacing={3}>
                {presentations.map((presentation, i) => (
                    <Grid item xs={12} md={6} key={i}>
                        <Card
                            elevation={2}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 2,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 8px 16px rgba(0, 62, 126, 0.2)'
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundColor: '#003E7E',
                                    color: 'white',
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5
                                }}
                            >
                                <VideoLibraryIcon sx={{ fontSize: 28 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600, flex: 1 }}>
                                    {presentation.title}
                                </Typography>
                            </Box>

                            <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                {presentation.description && (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
                                            {presentation.description}
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                    </>
                                )}

                                <Button
                                    href={`/presentation/${presentation._id}`}
                                    variant="contained"
                                    startIcon={<PlayCircleOutlineIcon />}
                                    fullWidth
                                    sx={{
                                        backgroundColor: '#FF6600',
                                        '&:hover': {
                                            backgroundColor: '#e55a00'
                                        }
                                    }}
                                >
                                    Watch Recording
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        );
    };

    renderYearAccordion = (year, presentations, panelId, isLatest = false) => {
        const { expanded } = this.state;
        const count = presentations ? presentations.length : 0;

        return (
            <Accordion
                expanded={expanded === panelId}
                onChange={this.handleAccordionChange(panelId)}
                elevation={3}
                sx={{
                    mb: 2,
                    borderRadius: 2,
                    overflow: 'hidden',
                    border: isLatest ? '2px solid #FF6600' : 'none',
                    '&:before': {
                        display: 'none'
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                        backgroundColor: expanded === panelId ? (isLatest ? '#FF6600' : '#003E7E') : 'rgba(0, 62, 126, 0.05)',
                        color: expanded === panelId ? 'white' : '#003E7E',
                        '&:hover': {
                            backgroundColor: expanded === panelId ? (isLatest ? '#e55a00' : '#00325a') : 'rgba(0, 62, 126, 0.1)'
                        },
                        transition: 'all 0.3s ease'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                        <CalendarTodayIcon sx={{ fontSize: 32 }} />
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                {year} Monthly Recordings
                            </Typography>
                        </Box>
                        <Chip
                            label={`${count} ${count === 1 ? 'Recording' : 'Recordings'}`}
                            sx={{
                                backgroundColor: expanded === panelId ? 'rgba(255, 255, 255, 0.2)' : '#003E7E',
                                color: 'white',
                                fontWeight: 600
                            }}
                        />
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 3, backgroundColor: 'white' }}>
                    {this.renderPresentations(presentations, year)}
                </AccordionDetails>
            </Accordion>
        );
    };

    render() {
        const { presentations21, presentations22, presentations23, presentations24, presentations25, presentations26 } = this.state;

        return (
            <Box>
                {this.renderYearAccordion('2026', presentations26, 'panel2026', true)}
                {this.renderYearAccordion('2025', presentations25, 'panel2025')}
                {this.renderYearAccordion('2024', presentations24, 'panel2024')}
                {this.renderYearAccordion('2023', presentations23, 'panel2023')}
                {this.renderYearAccordion('2022', presentations22, 'panel2022')}
                {this.renderYearAccordion('2021', presentations21, 'panel2021')}
            </Box>
        );
    }
}

export default PresentationList;